var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-pagination-loader"},[_c('b-pagination',{attrs:{"total":_vm.total,"current":_vm._page,"per-page":_vm.perPage,"order":"is-centered"},on:{"change":function($event){return _vm.$emit('update:page', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }